import { gql } from "@apollo/client";

export const ACTIVE_INCIDENT_QUERY = gql`
  query ACTIVE_INCIDENT_QUERY(
    $officerId: ID
    $homeOriId: ID
    $oriIds: String!
    $originatorId: ID!
    $noSessionReset: Boolean
  ) {
    activeIncidents(
      officerId: $officerId
      homeOriId: $homeOriId
      oriIds: $oriIds
      originatorId: $originatorId
      noSessionReset: $noSessionReset
    ) {
      id
      ori {
        id
        oriName
        abbreviation
      }
      uuid
      incidentNumber
      callTime
      classification {
        id
        name
      }
      officerIncidentSpecifics {
        id
        createdAt
        secondaryAddress
        currentOfficerStatus
        statusId
        logCodeId
        logCode {
          id
          name
        }
        dispatchedAt
        enrouteAt
        onSceneAt
        clearedAt
        primaryOfficer
        officer {
          id
          deptAttribute {
            id
            badge
            assignment
            loanerOriAbbreviations
            carNumber
            radioNumber
            lastContactedAt
            notes
            ori {
              id
              oriName
              abbreviation
            }
            secondaryAddress
            skillsList
            status
          }
        }
      }
      address {
        id
        name
        lat
        lng
        streetNumber
        streetName
        unit
        city
        validAddressAlerts {
          id
          alertType {
            id
            name
            alertLevel
          }
        }
      }
      personIncidentSpecifics {
        id
        sealed
        juvenile
        yoe
        person {
          id
          aliases {
            id
            target {
              id
              validPersonAlerts {
                id
                alertType {
                  id
                  name
                  alertLevel
                }
              }
            }
          }
          validPersonAlerts {
            id
            alertType {
              id
              name
              alertLevel
            }
          }
        }
      }
      sealed
      locked
    }
  }
`;
